import type { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'

/**
 * todo: Remove after useErrorBanner refactoring — error formatting (message + code) move into the hook itself?
 *
 * Concatenates a translated error message with the backend error code (if present).
 */
export const formatActionError = (
  message: string,
  errorCode: string | undefined,
  getTranslation: (key: Key) => string
): string => {
  const codeInfo = errorCode ? `${getTranslation('errorRedCodePrefix')} ${errorCode}` : ''
  return [message, codeInfo].filter(Boolean).join(' ')
}
